var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-template",
    [
      _c(
        "v-row",
        {
          staticClass: "py-0 main-row",
          attrs: {
            "justify-sm": "center",
            "justify-md": "center",
            "justify-lg": "center",
            "justify-xl": "center",
          },
        },
        [
          _c(
            "v-col",
            {
              class: { "mt-4": _vm.notXs, "pl-10": _vm.xs },
              attrs: { cols: "11" },
            },
            [
              _c(
                "v-row",
                [
                  _c("v-col", { attrs: { cols: "auto" } }, [
                    _c("img", {
                      staticClass: "arrow px-4 py-3",
                      attrs: { src: _vm.ic_back, id: "back-btn" },
                      on: { click: _vm.backToShipments },
                    }),
                  ]),
                  _c(
                    "v-col",
                    { staticClass: "ml-n4", attrs: { cols: "auto" } },
                    [
                      _c("label", { staticClass: "back-lbl" }, [
                        _vm._v("Back to Shipments "),
                      ]),
                    ]
                  ),
                  _c("v-spacer"),
                ],
                1
              ),
              _c(
                "v-row",
                { class: { "mt-n6": _vm.xs || _vm.sm } },
                [
                  _c(
                    "v-col",
                    { attrs: { cols: "12" } },
                    [
                      _c(
                        "v-row",
                        [
                          _c("v-col", { attrs: { cols: "12" } }, [
                            _c("label", { staticClass: "main-header" }, [
                              _vm._v("Generate Nationex Manifest"),
                            ]),
                          ]),
                          _c(
                            "v-col",
                            { staticClass: "mt-n5", attrs: { cols: "12" } },
                            [
                              _c("label", { staticClass: "sub-header" }, [
                                _vm._v(
                                  "Generate a Nationex manifest for your shipments."
                                ),
                              ]),
                            ]
                          ),
                        ],
                        1
                      ),
                      _c(
                        "v-row",
                        { staticClass: "mt-7 pb-7" },
                        [
                          _c(
                            "v-col",
                            { attrs: { cols: "5" } },
                            [
                              _c("smart-calendar", {
                                attrs: {
                                  label:
                                    "Select Date to Generate or Print a Nationex Manifest",
                                  maxDate: _vm.now("-"),
                                  minDate: _vm.oneMonthAgo("-"),
                                },
                                on: { change: _vm.manifestDateChanged },
                                model: {
                                  value: _vm.manifestDate,
                                  callback: function ($$v) {
                                    _vm.manifestDate = $$v
                                  },
                                  expression: "manifestDate",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "v-dialog",
        {
          attrs: {
            "max-width": "520px",
            "max-height": "757px",
            scrollable: "",
          },
          model: {
            value: _vm.displayConfirmPopup,
            callback: function ($$v) {
              _vm.displayConfirmPopup = $$v
            },
            expression: "displayConfirmPopup",
          },
        },
        [
          _c(
            "v-card",
            { staticClass: "px-5 pb-5 br-10" },
            [
              _c(
                "v-card-title",
                [
                  _c(
                    "v-row",
                    { staticClass: "mt-1" },
                    [
                      _c(
                        "v-col",
                        { staticClass: "ta-c", attrs: { cols: "12" } },
                        [
                          _c("label", { staticClass: "base header" }, [
                            _vm._v("Confirm Generation"),
                          ]),
                        ]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "v-card-text",
                [
                  _c(
                    "v-row",
                    { staticClass: "pl-0 mt-n3" },
                    [
                      _c(
                        "v-col",
                        { staticClass: "pl-0", attrs: { cols: "auto" } },
                        [
                          _c(
                            "label",
                            { staticClass: "nationex-confirm-text" },
                            [
                              _vm._v(
                                "You are about to generate today's Nationex manifest. Please ensure that all shipments for today have been created. Generating the manifest too early may result in incomplete data. Do you want to proceed?"
                              ),
                            ]
                          ),
                        ]
                      ),
                      _c(
                        "v-col",
                        { staticClass: "pl-0 mt-n2", attrs: { cols: "auto" } },
                        [
                          _c(
                            "label",
                            { staticClass: "nationex-confirm-text" },
                            [
                              _c("i", [
                                _vm._v(
                                  "Note: system will generate Nationex Manifest file for the following shipments created today: " +
                                    _vm._s(_vm.tmsShipmentIds)
                                ),
                              ]),
                            ]
                          ),
                        ]
                      ),
                    ],
                    1
                  ),
                  _c(
                    "v-row",
                    { staticClass: "ta-c w-100-pct mt-n4" },
                    [
                      _c(
                        "v-col",
                        { staticClass: "mt-8 pr-0", attrs: { cols: "12" } },
                        [
                          _c(
                            "v-flex",
                            [
                              _c("smart-btn", {
                                attrs: { type: "dismiss", label: "Cancel" },
                                on: { click: _vm.cancelConfirm },
                              }),
                              _c("smart-btn", {
                                staticClass: "ml-5",
                                attrs: { label: "Confirm", type: "primary" },
                                on: { click: _vm.confirmGenerate },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm.nationexManifestBase64Computed
        ? _c("div", { staticClass: "pdf-overlay" }, [
            _c("iframe", {
              staticStyle: { border: "none" },
              attrs: {
                src:
                  "data:application/pdf;base64," +
                  _vm.nationexManifestBase64Computed,
                width: "100%",
                height: "100%",
              },
            }),
          ])
        : _vm._e(),
      _c(
        "v-overlay",
        {
          attrs: {
            value: _vm.showLoadingScreen,
            opacity: "0.9",
            color: "#fff",
          },
        },
        [
          _c(
            "v-row",
            { staticClass: "mt-n16" },
            [
              _c(
                "v-col",
                {
                  staticClass: "text-center",
                  class: { "px-6": _vm.smAndDown },
                },
                [
                  _c("img", {
                    staticClass: "rotating",
                    attrs: { src: _vm.ic_loader_blue_big, width: "86" },
                  }),
                  _c("p", { staticClass: "overlay-txt mt-5" }, [
                    _vm._v(" " + _vm._s(_vm.loadingScreenMessage) + " "),
                  ]),
                ]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }